import HeartAltSVG from '../../assets/svg/heart-alt.svg';
export default HeartAltSVG;
